import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { RodapeComponent } from "./rodape/rodape.component";
import { IndicadoresComponent } from './components/indicadores/indicadores.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MenuComponent, RodapeComponent, IndicadoresComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  ngOnInit() {
    this.loadTawkTo();
  }

  loadTawkTo() {
    // Verifica se o script já está carregado para evitar múltiplos carregamentos
    if (document.getElementById("tawk-script")) {
      console.log("Tawk.to já carregado.");
      return;
    }

    var script = document.createElement("script");
    script.id = "tawk-script"; // Define um ID para evitar múltiplas inserções
    script.async = true;
    script.src = "https://embed.tawk.to/59ad9f3cc28eca75e461e135/default";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    script.onload = () => {
      console.log("Tawk.to carregado!");
      (window as any).Tawk_API = (window as any).Tawk_API || {};
    };

    document.head.appendChild(script);
  }
}
